const orders = [{
  path: '/customer_orders',
  component: () => import('@/views/orders/customer/View'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    component: () => import('@/views/orders/customer/List')
  }, {
    path: ':order_id',
    component: () => import('@/views/orders/customer/Item')
  }, {
    path: ':order_id/pick',
    name: 'customer_pick_order',
    component: () => import('@/views/orders/customer/Pick')
  }]
}, {
  path: '/supplier_orders',
  component: () => import('@/views/orders/supplier/View'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    component: () => import('@/views/orders/supplier/List')
  }, {
    path: ':order_id',
    component: () => import('@/views/orders/supplier/Item')
  }, {
    path: ':order_id/pick',
    name: 'supplier_pick_order',
    component: () => import('@/views/orders/supplier/Pick')
  }]
}, {
  path: '/adjustment_orders',
  component: () => import('@/views/orders/adjustment/View'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    component: () => import('@/views/orders/adjustment/List')
  }, {
    path: ':order_id',
    component: () => import('@/views/orders/adjustment/Item')
  }, {
    path: ':order_id/adjust',
    name: 'adjust_order',
    component: () => import('@/views/orders/adjustment/Adjust')
  }]
}, {
  path: '/transfer_orders',
  component: () => import('@/views/orders/transfer/View'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    component: () => import('@/views/orders/transfer/List')
  }, {
    path: ':order_id',
    component: () => import('@/views/orders/transfer/Item')
  }, {
    path: ':order_id/transfer/:mode',
    name: 'transfer_order',
    component: () => import('@/views/orders/transfer/Mode')
  }]
}, {
  path: '/product_view',
  component: () => import('@/views/orders/ProductView'),
  meta: { requiresAuth: true }
}]
export default orders
